import React from 'react';
import Navbar from './Navbar';
import './AboutPage.css';

const TEAM = [
  {
    name: 'Clara Rhoades',
    photo: `${process.env.PUBLIC_URL}/images/clara.png`,
    linkedin: 'https://www.linkedin.com/in/clara-rhoades/',
  },
  {
    name: 'Nichol Flowers',
    photo: `${process.env.PUBLIC_URL}/images/nichol.png`,
    linkedin: 'https://www.linkedin.com/in/nicholflowers/',
  },
  {
    name: 'Keta Desai',
    photo: `${process.env.PUBLIC_URL}/images/keta.png`,
    linkedin: 'https://www.linkedin.com/in/keta-desai-3b3b2128/',
  },
  {
    name: 'Katya Aukamp',
    photo: `${process.env.PUBLIC_URL}/images/katya.png`,
    linkedin: 'https://www.linkedin.com/in/katya-aukamp/',
  },
];

export default function AboutPage() {
  return (
    <div className="about-page">
      <Navbar />

      {/* ── Logo header ──────────────────────────────────────────────── */}
      <div className="about-logo-section">
        <img
          src={`${process.env.PUBLIC_URL}/images/logo.png`}
          alt="Eye2Voice"
          className="about-logo"
        />
      </div>

      {/* ── Hero / team section ───────────────────────────────────────── */}
      <section className="about-hero">

        <div className="about-hero-text">
          <h1 className="about-heading">Our Team</h1>
          <p className="about-subheading">
            Our philosophy was simple; build something impactful.
          </p>
        </div>

        <div className="team-grid">
          {TEAM.map(member => (
            <div key={member.name} className="team-member">
              <h2 className="team-member-name">{member.name}</h2>
              <img
                src={member.photo}
                alt={member.name}
                className="team-member-photo"
              />
              <a
                href={member.linkedin}
                className="team-member-linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </div>
          ))}
        </div>

      </section>

      {/* ── Footer ───────────────────────────────────────────────────── */}
      <footer className="about-footer">
        <p className="footer-text">
          UC Berkeley Masters of Information and Data Science Capstone Project
        </p>
        <a className="footer-email" href="mailto:eyetovoice@gmail.com">
          eyetovoice@gmail.com
        </a>
      </footer>
    </div>
  );
}
